export const PROFANE_WORDS = [
    'xxx',
    'xrated',
    'willy',
    'willies',
    'whore',
    'wanky',
    'wanker',
    'wank',
    'wang',
    'vulva',
    'viagra',
    'vagina',
    'twatty',
    'twathead',
    'twat',
    'turd',
    'tosser',
    'titwank',
    'tittywank',
    'tittyfuck',
    'titties',
    'tittiefucker',
    'titt',
    'tits',
    'titfuck',
    'tit',
    'testicle',
    'testical',
    'teets',
    'spunk',
    'spac',
    'son-of-a-bitch',
    'snatch',
    'smut',
    'smegma',
    'sluts',
    'slut',
    'skank',
    'shitty',
    'shittings',
    'shitting',
    'shitters',
    'shitter',
    'shitted',
    'shits',
    'shitings',
    'shiting',
    'shithead',
    'shitfull',
    'shitfuck',
    'shitey',
    'shited',
    'shite',
    'shitdick',
    'shit',
    'shemale',
    'shagging',
    'shaggin',
    'shagger',
    'shag',
    'sex',
    'semen',
    'scrotum',
    'scrote',
    'scroat',
    'screwing',
    'schlong',
    'sadist',
    'rimming',
    'rimjaw',
    'retard',
    'rectum',
    'pussy',
    'pussies',
    'pube',
    'pricks',
    'prick',
    'pornos',
    'pornography',
    'porno',
    'porn',
    'poop',
    'pissoff',
    'pissing',
    'pissflaps',
    'pisses',
    'pissers',
    'pisser',
    'pissed',
    'piss',
    'pimpis',
    'pigfucker',
    'phonesex',
    'penisfucker',
    'penis',
    'pecker',
    'orgasms',
    'orgasm',
    'nutsack',
    'numbnuts',
    'nobjokey',
    'nobjocky',
    'nobhead',
    'nob',
    'niggers',
    'nigger',
    'niggaz',
    'niggas',
    'niggah',
    'nigga',
    'nazi',
    'muff',
    'motherfucks',
    'motherfuckka',
    'motherfuckings',
    'motherfucking',
    'motherfuckin',
    'motherfuckers',
    'motherfucker',
    'motherfucked',
    'motherfuck',
    'mother fucker',
    'mofo',
    'mo-fo',
    'masturbate',
    'masterbations',
    'masterbation',
    'masterbate',
    'master-bate',
    'masochist',
    'lusting',
    'lust',
    'lmfao',
    'labia',
    'knobjokey',
    'knobjocky',
    'knobhead',
    'knobend',
    'knobed',
    'knobead',
    'knob',
    'jizz',
    'jiz',
    'jism',
    'jerk-off',
    'jap',
    'jackoff',
    'jack-off',
    'hotsex',
    'horny',
    'horniest',
    'homo',
    'hoar',
    'heshe',
    'hell',
    'hardcoresex',
    'goddamned',
    'goddamn',
    'god-damned',
    'god-dam',
    'goatse',
    'gaysex',
    'gaylord',
    'gangbangs',
    'gangbanged',
    'gangbang',
    'fudgepacker',
    'fudge packer',
    'fuckwit',
    'fuckwhit',
    'fucks',
    'fuckme',
    'fuckingshitmotherfucker',
    'fuckings',
    'fucking',
    'fuckin',
    'fuckheads',
    'fuckhead',
    'fuckers',
    'fucker',
    'fucked',
    'fuck',
    'flange',
    'fistfucks',
    'fistfuckings',
    'fistfucking',
    'fistfuckers',
    'fistfucker',
    'fistfucked',
    'fistfuck',
    'fingerfucks',
    'fingerfucking',
    'fingerfuckers',
    'fingerfucker',
    'fingerfucked',
    'fingerfuck',
    'fellatio',
    'fellate',
    'felching',
    'fatass',
    'fannyfucker',
    'fannyflaps',
    'fanny',
    'fags',
    'faggot',
    'faggitt',
    'fagging',
    'fag',
    'ejaculation',
    'ejaculatings',
    'ejaculating',
    'ejaculates',
    'ejaculated',
    'ejaculate',
    'dyke',
    'duche',
    'doosh',
    'donkeyribber',
    'dogging',
    'doggin',
    'dog-fucker',
    'dirsa',
    'dinks',
    'dink',
    'dildos',
    'dildo',
    'dickhead',
    'dick',
    'damn',
    'cyberfucking',
    'cyberfuckers',
    'cyberfucker',
    'cyberfucked',
    'cyberfuck',
    'cyalis',
    'cunts',
    'cuntlicking',
    'cuntlicker',
    'cuntlick',
    'cunt',
    'cunnilingus',
    'cunillingus',
    'cunilingus',
    'cumshot',
    'cums',
    'cumming',
    'cummer',
    'cum',
    'crap',
    'cox',
    'coon',
    'cocksucks',
    'cocksucking',
    'cocksucker',
    'cocksucked',
    'cocksuck',
    'cocks',
    'cockmuncher',
    'cockmunch',
    'cockhead',
    'cockface',
    'cock-sucker',
    'cock',
    'clits',
    'clitoris',
    'clit',
    'cipa',
    'chink',
    'cawk',
    'carpet muncher',
    'buttplug',
    'buttmuch',
    'butthole',
    'butt',
    'bunny fucker',
    'bum',
    'bugger',
    'buceta',
    'breasts',
    'boobs',
    'boob',
    'boner',
    'bollok',
    'bollock',
    'boiolas',
    'blowjobs',
    'blowjob',
    'blow job',
    'bloody',
    'bitching',
    'bitchin',
    'bitches',
    'bitchers',
    'bitcher',
    'bitch',
    'bestiality',
    'bestial',
    'bellend',
    'beastiality',
    'beastial',
    'bastard',
    'ballsack',
    'ballbag',
    'asswhole',
    'assholes',
    'asshole',
    'assfucker',
    'asses',
    'ass-fucker',
    'ass',
    'arse',
    'anus',
    'anal',
]
